import { memo, useContext } from "react";
import style from "./agreement.module.css";
import { MainLayoutContext } from "../../layouts/MainLayout";

const Agreement = () => {
  const { setIsOpen } = useContext(MainLayoutContext);

  return (
    <section className={style.wrapper}>
      <h2 className={style.age}>18+</h2>
      <p className={style.ph_prim}>
        Добро пожаловать на сайт дистрибьютора <span>ПРИМПИВО</span>. Данный
        ресурс содержит информацию только для лиц, достигших совершеннолетнего
        возраста. Для входа на сайт, подтвердите свой возраст. В ином случае
        покиньте сайт.
      </p>
      <button
        className={style.confirm}
        onClick={() =>
          setIsOpen((prev) => {
            return { ...prev, agreement: false };
          })
        }
      >
        <p className={style.btn_text}>Мне исполнилось 18 лет</p>
        <div className={style.wave_btn}></div>
      </button>
      <p className={style.ph_policy}>
        Наш сайт использует файлы cookie для сбора данных о посещении страниц с
        помощью Google Analytics и Yandex Metrika. Продолжая просмотр страниц
        нашего сайта, вы принимаете условия его использования. Более подробные
        сведения см. в нашей
        <button
          className={style.btn_policy}
          onClick={() =>
            setIsOpen((prev) => {
              return { ...prev, policy: true };
            })
          }
        >
          политике конфедециальности и условиях использования
        </button>
        .
      </p>
    </section>
  );
};

export default memo(Agreement);
